(function () {
    'use strict';
    const APP_ID = 'gglb96sn';
    const API_BASE = 'https://api-iam.eu.intercom.io';
    const INTERCOM_DEBUG = true;
    var tokenWatchCallCount = 0;
    var tokenWatchWindowStart = performance.now();

    angular.module('itero').run(['$rootScope', '$window', '$http', 'PublicSettings', function ($rootScope, $window, $http, PublicSettings) {
        
        if (!PublicSettings.IntercomConfigured) {
            return;
        }

        function shutdown() {
            try {
                if (typeof $window.Intercom === 'function') $window.Intercom('shutdown');
            } catch (e) {
            }
            $window.INTERCOM_SHUTDOWN = true;
            delete $window.intercomSettings;
        }

        function loadWidget() {
            let w = $window, ic = w.Intercom;
            
            if (typeof ic === 'function') {
                ic('reattach_activator');
                ic('update', w.intercomSettings || {});
                return;
            }

            let intercomQueue = function () {
                intercomQueue.enqueue(arguments);
            };
            intercomQueue.queue = [];
            intercomQueue.enqueue = function (args) {
                intercomQueue.queue.push(args);
            };
            w.Intercom = intercomQueue;

            function inject() {
                let scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.async = true;
                scriptElement.src = 'https://widget.intercom.io/widget/' + APP_ID;
                let x = document.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(scriptElement, x);
            }

            if (document.readyState === "complete") inject();
            else if (w.attachEvent) w.attachEvent("onload", inject);
            else w.addEventListener("load", inject, false);
        }

        function buildSettings(jwtToken) {
            let ent = $rootScope.chosenEntity;
            if (!ent) {
                try { ent = JSON.parse(localStorage.getItem('chosenEntity') || 'null'); }
                catch (e) { ent = null; }
            }

            if (!ent || !ent.Id) return null;
           
            const settings = {
                api_base: API_BASE,
                app_id: APP_ID
            };

            if (jwtToken) {
                settings.intercom_user_jwt = jwtToken;
            }

            return settings;
        }

        function bootOrUpdate(jwtToken) {
            var bootStart = performance.now();
            if (INTERCOM_DEBUG) console.log('[Frida] bootOrUpdate called at', bootStart.toFixed(1), 'ms');
            if (!$window.intercomSettings) {
                let settings = buildSettings(jwtToken);
                if (!settings) return;
                $window.intercomSettings = settings;
            }
            loadWidget();
            if (typeof $window.Intercom !== 'function') return;

            if ($window.INTERCOM_SHUTDOWN) {
                if (INTERCOM_DEBUG) console.log('[Frida] Calling Intercom("boot") at', performance.now().toFixed(1), 'ms');
                $window.Intercom('boot', $window.intercomSettings);
                $window.INTERCOM_SHUTDOWN = false;
            } else {
                if (INTERCOM_DEBUG) console.log('[Frida] Calling Intercom("update") at', performance.now().toFixed(1), 'ms');
                $window.Intercom('update', $window.intercomSettings);
            }
            if (INTERCOM_DEBUG) console.log('[Frida] bootOrUpdate finished in', (performance.now() - bootStart).toFixed(1), 'ms');
        }

        function fetchIntercomToken() {
            return $http({
                method: 'GET',
                url: '/api/v1/intercom/token',
                cache: false
            }).then(function(response) {
                return response.data && response.data.IntercomUserJwt ? response.data.IntercomUserJwt : null;
            }).catch(function(error) {
                console.warn('Failed to fetch Intercom JWT token:', error);
                return null;
            });
        }

        function initIntercomOnReady() {
            if (INTERCOM_DEBUG) console.log('[Frida] initIntercomOnReady called at', performance.now().toFixed(1), 'ms');
            let unwatch = $rootScope.$watch(function () {
                return !!($rootScope.user && $rootScope.chosenEntity);
            }, function (ready) {
                if (!ready) return;
                unwatch();

                if (INTERCOM_DEBUG) console.log('[Frida] user & entity ready — fetching JWT at', performance.now().toFixed(1), 'ms');

                // external_user is only set on regular login; absence means HQ admin session — skip Intercom entirely
                const extUser = localStorage.getItem("external_user");
                if (!extUser || extUser === "null" || extUser === "undefined") return;

                // Always rebuild with new data
                delete $window.intercomSettings;

                // Fetch JWT token and then boot/update Intercom
                fetchIntercomToken().then(function(jwtToken) {
                    if (!jwtToken) return;
                    if (INTERCOM_DEBUG) console.log('[Frida] JWT fetched — calling bootOrUpdate at', performance.now().toFixed(1), 'ms');
                    bootOrUpdate(jwtToken);
                });
            });
        }

        initIntercomOnReady();

        // Login/logout handling
        $rootScope.$watch(function () {
            tokenWatchCallCount++;
            var now = performance.now();
            var elapsed = now - tokenWatchWindowStart;
            if (elapsed >= 5000) {
                if (INTERCOM_DEBUG) console.warn('[Frida] Token watcher getter called', tokenWatchCallCount, 'times in the last', (elapsed / 1000).toFixed(1), 's (' + (tokenWatchCallCount / (elapsed / 1000)).toFixed(0), 'calls/sec)');
                tokenWatchCallCount = 0;
                tokenWatchWindowStart = now;
            }
            return $rootScope.getStoredAccessToken();
        }, function (newValue, oldValue) {
            if (oldValue && !newValue) { // logout
                if (INTERCOM_DEBUG) console.log('[Frida] Token watcher: logout detected');
                shutdown();
                initIntercomOnReady();
            } else if (!oldValue && newValue) { // login
                if (INTERCOM_DEBUG) console.log('[Frida] Token watcher: login detected');
                initIntercomOnReady();
            }
        });
    }]);
})();
